import React from 'react'
import './Checkout.css'
import Subtotal from './Subtotal';
import { useStateValue } from '../StateProvider';
import CheckoutProduct from './CheckoutProduct';
import FlipMove from 'react-flip-move';

function Checkout() {
    const [{ basket, user }, dispatch ] = useStateValue();

    return (
        <div className="checkout">
            <div className="checkout__left"> 
             <img className="checkout__ad"
             alt="banner"
             src="https://images-eu.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492688.jpg" 
             />
<div>
    <h3>Hi, {user?.email} </h3>
    <h2 className="checkout__title">Your Shopping Basket</h2>
    <FlipMove>
{basket.map(item => (
   
    <CheckoutProduct 
    id={item.id}
    title={item.title}
    image={item.image}
    price={item.price}
    rating={item.rating}
    />
    
))}
</FlipMove>
</div>
 </div>


            <div className="checkout__right">
            <Subtotal />
            </div>
        </div>
    );
}

export default Checkout
